/* reporté de theme.liquid code custom inline 2026-09-17 */
(function () {
  try {
    const saved = JSON.parse(
      sessionStorage.getItem('slSynonymSearch') || 'null'
    );

    const params = new URLSearchParams(window.location.search);
    const currentQuery = params.get('q') || '';

    if (saved && saved.expanded === currentQuery) {
      document.documentElement.classList.add('sl-synonym-search-loading');
    }
  } catch (e) {}
})();

/* reporté de search-drawer.liquid code custom inline 2026-09-17 */
/* Enlever le texte "Aucun résultat trouvé" dans le predictive search. (Thomas) */
document.addEventListener("DOMContentLoaded", function () {

  const predictive = document.querySelector("predictive-search");

  if (!predictive) return;

  const observer = new MutationObserver(() => {

    const emptyState = predictive.querySelector(".empty-state");

    if (emptyState) {
      predictive.classList.remove("is-active"); 
      predictive.style.visibility = "hidden";
    } else {
      predictive.style.visibility = "visible";
    }

  });

  observer.observe(predictive, {
    childList: true,
    subtree: true
  });

});